import { useState } from 'react';

import { useTheme } from '@mui/system';

import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';

import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import { useFormatters } from '@/hooks';

import { PortfolioCard } from './PortfolioCard';
import { Portfolio } from './cnaught-portfolios';
import Portfolios from './cnaught-portfolios.json';

interface PortfoliosDialogProps {
  open: boolean;
  value: number;
  onClose: () => void;
}

function PortfoliosDialog(props: PortfoliosDialogProps) {
  const theme = useTheme();
  const { open, value, onClose } = props;
  const { formatNumber } = useFormatters();

  const [fakeLoading, setFakeLoading] = useState(false);
  const [fakeConfirm, setFakeConfirm] = useState(false);
  const [portfolio, setPortfolio] = useState<Portfolio | null>(null);

  const handlePortfolioClick = (portfolio: Portfolio) => () => {
    setPortfolio(portfolio);
    setFakeLoading(true);
    setTimeout(() => {
      setFakeConfirm(true);
      setTimeout(() => {
        onClose();
        setTimeout(() => {
          setFakeConfirm(false);
          setFakeLoading(false);
          setPortfolio(null);
        }, 1000);
      }, 3000);
    }, 3000);
  };

  return (
    <Dialog maxWidth="lg" open={open} onClose={onClose}>
      <DialogTitle>Carbon offset portfolio</DialogTitle>
      <DialogContent>
        {fakeLoading ? (
          <Box sx={{ p: 16 }}>
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="center"
              spacing={2}
            >
              <Typography variant="h4">{portfolio.name}</Typography>
              <Typography color={theme.palette.grey[600]}>
                {fakeConfirm
                  ? `Order #${Math.round(Math.random() * 1024)} confirmed`
                  : `Placing an order for ${formatNumber(value)} kg of carbon credits`}
              </Typography>
              {fakeConfirm ? (
                <CheckCircleOutlineIcon
                  sx={{ fontSize: 94 }}
                  color="secondary"
                />
              ) : (
                <CircularProgress size={64} />
              )}
            </Stack>
          </Box>
        ) : (
          <Stack direction="column" alignItems="center" spacing={2}>
            <DialogContentText fontSize={20}>
              Choose portfolio to offset{' '}
              <strong
                style={{
                  backgroundColor: theme.palette.secondary.main,
                  color: theme.palette.secondary.contrastText,
                  letterSpacing: 1,
                }}
              >
                {' '}
                {formatNumber(value)} kg
              </strong>{' '}
              of carbon.
            </DialogContentText>
            <Divider />
            <Stack direction="row" alignItems="cente" spacing={2}>
              {Portfolios.map((portfolio: Portfolio) => (
                <PortfolioCard
                  key={portfolio.id}
                  portfolio={portfolio}
                  onClick={handlePortfolioClick(portfolio)}
                />
              ))}
            </Stack>
          </Stack>
        )}
      </DialogContent>
    </Dialog>
  );
}

export { PortfoliosDialog };
